import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import MailingAddressForm from './forms/MailingAddressForm'

const MailingAddressView = ({ t, i18n, setIsError }) => {
  const history = useHistory()

  const [validateForm, setValidateForm] = useState()

  const onNext = () => {
    try {
      const newData = validateForm()
      if (newData) {
        history.push(`/${i18n.language}${t('routes.review_summary')}`)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  return (
    <div className="container">
      <BackAnchor />
      <div className="row">
        <div className="col-xs-12">
          <h2>{t('mailing_address.title')}</h2>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 col-md-8">
          <MailingAddressForm setValidateForm={setValidateForm} setIsError={setIsError} />
        </div>
      </div>
      <div className="col-xs-12 col-md-8">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ContinueCancelButtons continueClick={onNext} showCancel={false} />
        </div>
      </div>
    </div>
  )
}

export default withTranslation('common')(MailingAddressView)
